import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  scrollView: {
    paddingBottom: 24,
    paddingHorizontal: 16,
  },
  containerGroupToolOptions: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 12,
  },
  groupTitleContainer: {
    width: '100%',
    marginTop: 16,
  },
  groupTitle: {
    fontWeight: 700,
    fontSize: 14,
  },
});
